import { upgrade } from '@ff-os/shared-utils/upgrades/upgrades';
import { GiftJson } from '@ff-scene-plugins/gift-shared/GiftJson';
import { giftUpgrades } from '@ff-scene-plugins/gift-shared/upgrades/giftUpgrades';

export const initializeProject = (sceneProject: GiftJson.Project) => {
    return upgrade(sceneProject, { allUpgrades: giftUpgrades });
};